"use strict";

var youi = require('@yola/youi').default;
var _ = require("lodash");

var modalObjects = {};

var init = _.partial(youi.views.modalManager.init, modalObjects);

var modals = {
  init: init,
};

module.exports = modals;
